import React, { Component } from 'react'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'


import formatReport from '../utils/format-report-jfc'

const Office = window.Office

export default class Report extends Component {
    constructor(props) {
      super(props)
      this.props = props

    this.generateReport = this.generateReport.bind(this)
    this.officeMessage = this.officeMessage.bind(this)

      this.state = {status:'initializing',selected: 0, message: ''} 

      
      
    }

    componentDidMount() {
      if (Office) Office.initialize = (asyncResult)  => {
        this.setState( {message:"Started"});
        if (asyncResult.status === window.Office.AsyncResultStatus.Succeeded) {
            this.setState( {message:""});
          } else {
            this.setState( {message:asyncResult.error.message});
          }
      }
    }

    handleOfficeInitialize(reason) {
        console.log(reason) 
        this.setState({status: reason})
    }

    officeMessage(asyncResult) {
        this.setState( {message:"Started"});
        if (asyncResult.status === window.Office.AsyncResultStatus.Succeeded) {
            this.setState( {message:""});
          } else {
            this.setState( {message:asyncResult.error.message});
          }
      }
    

    generateReport(e) {
        const data = formatReport(this.props.data)
        Office.context.document.setSelectedDataAsync(data, {coercionType: Office.CoercionType.Html},
          this.officeMessage)
    }
    render() {
        const { status, message } = this.state

        return <div> 

        
        </div>
    }
}
/*
        {status != 'initializing' ? <PrimaryButton text="Generate Report" onClick={this.generateReport} /> : <div>{status}</div>}
        <PrimaryButton text="Generate Report" onClick={this.generateReport} />
        {message}
        */


// WEBPACK FOOTER //
// ./src/modules/competencies/components/Report.js